import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { GoogleMap, Marker,Polyline } from "@capacitor/google-maps";
import { NavController } from '@ionic/angular';
import { googleMapsApiKey } from '../../../../../../../../common/runtime-config';
import {NavigationOptions} from "@ionic/angular/providers/nav-controller";
@Component({
  selector: 'app-product-tracking-map',
  templateUrl: './product-tracking-map.component.html',
  styleUrls: ['./product-tracking-map.component.scss'],
})
export class ProductTrackingMapComponent implements OnInit {
  @Input("steps") steps: any;
  @Input("ean") ean: any;
  @Input("batchId") batchId: any;
  map: GoogleMap;
  @ViewChild("trackingMap") trackingMap: ElementRef<HTMLElement>
  mapZoom:number = 12;
  markers:Array<any> = [];
  constructor(private navController: NavController) { }
  polyline:  Polyline;
  polylineOptions: any = {strokeColor: '#000000', strokeOpacity: 1, strokeWeight: 5};
  // Pasa a false cuando ninguna etapa del lote tiene ubicacion publicada (ver initTrackingMap).
  showMap = true
  ngOnInit() {
    // `steps` is optional: a product whose lot has nothing published, or one whose input has
    // not arrived yet when this timer fires, used to reach the loop below with `undefined` and
    // throw inside an async nobody awaits — an unhandled rejection in the browser of whoever
    // scanned the QR. With no step there is no map to build, so it returns.
    setTimeout(() => {
      if (!this.steps || this.steps.length === 0) return
      this.initTrackingMap()
    }, 500)
  }


  async initTrackingMap(){
    // Production bug: getMarker() used to re-index .activities[0] on a value that is
    // ALREADY a single activity (step.activities[0], extracted right here) - every group
    // coming out of TrackingService.generateTrackingStructure() has >= 1 activity by
    // construction, but an activity itself has no .activities field, so getMarker always
    // threw "Cannot read properties of undefined (reading '0')" the moment a step had any
    // data at all. Fixed getMarker() below to read step.facility directly, like the portesa
    // sibling of this component already does. Kept this guard (mirroring portesa's
    // `if (activity && activity.facility)`) so a step whose first activity has no facility
    // is skipped instead of producing a marker with NaN coordinates.
    await this.steps.map((step:any)=>{
      const activity = step?.activities?.[0]
      if (!activity || !activity.facility) {
        return
      }
      const marker = this.getMarker(activity);
      this.markers.push(marker)
    })

    // Ni una etapa con ubicacion publicada: `markers` queda vacio y NO hay mapa que pintar.
    // Sin esta salida, `getCenterByMarkers()` hace `Math.min(...[])` -> Infinity y
    // `Math.max(...[])` -> -Infinity, el centro sale NaN y el mapa se crea apuntando a ninguna
    // parte: un recuadro gris vacio en la pagina de quien escanea. Encontrado en PRODUCCION el
    // 2026-10-04 (hilo sysadmin) con un lote de DIMITRA. La seccion entera se oculta, que es el
    // estado honesto: no hay ubicaciones, no hay mapa. Se usa [hidden] y no *ngIf para no
    // destruir el elemento que `trackingMap` referencia.
    if (this.markers.length === 0) {
      this.showMap = false
      return
    }

    // Creating the real map can reject for reasons entirely outside our control - a
    // visitor with the Google Maps script blocked, no network, or an expired/quota-exceeded
    // API key. That is a real, expected outcome for the public QR page, not a bug, so it must
    // be caught and logged instead of becoming an unhandled promise rejection that would take
    // the rest of the page down with it.
    try {
      this.map = await GoogleMap.create({
        id: "tracking-map",
        element: this.trackingMap.nativeElement,
        apiKey: googleMapsApiKey(),
        config: {
          center: this.getCenterByMarkers(),
          zoom: this.mapZoom,
          disableDefaultUI: true, 
          styles: [
            {
              featureType: "all",
              elementType: "all",
              stylers: [
                {
                  saturation: -100, 
                },
                {
                  lightness: 0, 
                },
              ],
            },
          ],
        },
      });

      this.markers.map((marker:any)=>{
        this.map.addMarker(marker)
      })

      this.addPolyLines()
    } catch (error) {
      console.error("ProductTrackingMapComponent: no se pudo inicializar el mapa", error)
    }
  }

  addPolyLines(){
    const path = this.markers.map((coord: any) => {
      return ({lat: coord.coordinate.lat, lng: coord.coordinate.lng})
    });
    const lines: Polyline[] = [
     {
      path: path,
      ...this.polylineOptions
     }
    ]

    this.map.addPolylines(lines)

  }
  getMarker(step): Marker {
    // step here is already a single activity (see initTrackingMap) - it has its own
    // .facility, not a nested .activities array.
    const lati = parseFloat(step.facility.latitude);
    const longi = parseFloat(step.facility.longitude);

    return {
        coordinate: {
            lat: lati,
            lng: longi
        },
        iconUrl:'/assets/img/portesa/map-marker.png',
        iconAnchor: { x: 23, y: 40 },
        iconOrigin: { x: 0, y: 0 },
        iconSize:{
          width: 40, 
          height: 40,
        },
        title: step.facility.name,
        snippet: step.facility.address
    }
}
 getCenterByMarkers() {

        const minLat = Math.min(...this.markers.map((coord: any) => coord.coordinate.lat));
        const maxLat = Math.max(...this.markers.map((coord: any) => coord.coordinate.lat));
        const minLng = Math.min(...this.markers.map((coord: any) => coord.coordinate.lng));
        const maxLng = Math.max(...this.markers.map((coord: any) => coord.coordinate.lng));

        const centerLat = (minLat + maxLat) / 2;
        const centerLng = (minLng + maxLng) / 2;

        const latDistance = Math.abs(maxLat - minLat);
        const lngDistance = Math.abs(maxLng - minLng);

        const zoomLevel = this.calculateZoomLevel(latDistance, lngDistance);
        const center = {lat: centerLat, lng: centerLng};
        this.mapZoom = zoomLevel;
        return center;
    }

    calculateZoomLevel(latDistance: number, lngDistance: number): number {
      
        const maxDistance = Math.max(latDistance, lngDistance);
        const worldWidth = 256; 
        const zoom = Math.floor(Math.log2(worldWidth / maxDistance));
        return zoom;
    }


    showTrackingMapPage(){

      this.navController.navigateForward("/tracking-map/" + this.ean + "/" + this.batchId)
    }
}
